import React, { useState, useEffect } from 'react';
import '../Assets/Stylesheets/Components/PasswordGate.scss';

const PasswordGate = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // Optional alpha gate. Set REACT_APP_SITE_GATE_PASSWORD in the environment to
  // enable it; when unset (e.g. general availability) the gate is disabled so
  // no password is shipped in the client bundle.
  const GATE_PASSWORD = process.env.REACT_APP_SITE_GATE_PASSWORD || '';
  const SESSION_KEY = 'trnd_gate_auth';

  useEffect(() => {
    // No password configured -> gate disabled (public launch).
    if (!GATE_PASSWORD) {
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }
    // Check if already authenticated in this session
    const authStatus = sessionStorage.getItem(SESSION_KEY);
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, [GATE_PASSWORD]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === GATE_PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  // Show loading briefly while checking session
  if (isLoading) {
    return (
      <div className="password-gate">
        <div className="password-gate-container">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  // If authenticated, show the app
  if (isAuthenticated) {
    return <>{children}</>;
  }

  // Show password gate
  return (
    <div className="password-gate">
      <div className="password-gate-container">
        <div className="password-gate-content">
          <div className="logo">
            <h1>TRND</h1>
          </div>
          
          <div className="gate-info">
            <h2>Alpha Access</h2>
            <p>This site is currently in alpha testing.</p>
            <p>Please enter the access password to continue.</p>
            <p className="note">Note: This is just site access protection. You'll still need to log in with your account to access features.</p>
          </div>

          <form onSubmit={handleSubmit} className="password-form">
            <div className="form-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="password-input"
                autoFocus
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="submit-button">
              Access Site
            </button>
          </form>

          <div className="gate-footer">
            <p>Don't have access? Contact your team administrator.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;

